const abacusCoreApiBaseUrl = process.env.NODE_ENV == "production" ? "https://settings-api.abacus.co" : "http://localhost:9806";
const apiKey = process.env.NODE_ENV == "production" ? "" : "8l8mYaSBd8A55BREMmkLVYw1eznR2bkICbWxKIkdL8U=";
const tokenUser = {
  username: "bbqfridays",
  company: "2016949"
};

export default { abacusCoreApiBaseUrl, apiKey, tokenUser };
